<template>
  <div class="choice-vote">
    <choice-vote-content :items="items" />
    <div v-if="showMoreRank" class="mt-3">
      <el-button class="w-full" @click="onShowMoreRank">查看更多排名</el-button>
    </div>
  </div>
</template>

<script>
import { questionType } from 'dygc'
import choice from '@/vote/choice'
import { createPopup } from '@/assets/js/factory'
import ChoiceMoreRank from '@/vote/ChoiceMoreRank.vue'
import ChoiceVoteContent from '@/vote/ChoiceVoteContent.vue'

export default {
  name: 'ChoiceVote',
  components: { ChoiceVoteContent },
  mixins: [choice],
  type: [questionType.SINGLE_CHOICE, questionType.MULTIPLE_CHOICE, questionType.SINGLE_SELECT, questionType.MULTIPLE_SELECT],
  computed: {
    showMoreRank() {
      return this.items.length > 5
    }
  },
  methods: {
    onShowMoreRank() {
      createPopup(ChoiceMoreRank, {
        items: this.items,
        question: this.question
      })
    }
  }
}
</script>